"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_tv__epg__backwards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;}.cls-1,.cls-2{stroke:#333;stroke-linecap:round;stroke-width:8px;}.cls-1{stroke-linejoin:round;}.cls-2{stroke-miterlimit:10;}")), /*#__PURE__*/React.createElement("title", null, "tv-epg-backwards"), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,73.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.5,90.06",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.07,73.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,123.06",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.5,
    y1: 124.06,
    x2: 27.5,
    y2: 124.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "36.47 107.06 19.5 124.03 36.47 141"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,92.06v-48a8,8,0,0,1,8-8H164a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8H68",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60,
    y1: 156.06,
    x2: 132,
    y2: 156.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96,
    y1: 144.06,
    x2: 96,
    y2: 154.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.74,92.06",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "c45be5bf-2d1d-4160-a721-0350962aa154",
    className: "cls-2",
    x1: 84,
    y1: 92.06,
    x2: 44,
    y2: 92.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 84,
    y1: 76.06,
    x2: 44,
    y2: 76.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 84,
    y1: 60.06,
    x2: 44,
    y2: 60.06
  }), /*#__PURE__*/React.createElement("line", {
    id: "cbbf7d26-592f-4d0d-81ab-1f65ba0952d8",
    className: "cls-2",
    x1: 84,
    y1: 108.06,
    x2: 52,
    y2: 108.06
  }), /*#__PURE__*/React.createElement("line", {
    id: "fc7d0b35-edbc-4fc7-a7b8-fa8b83bec80b",
    className: "cls-2",
    x1: 148,
    y1: 92.06,
    x2: 108,
    y2: 92.06
  }), /*#__PURE__*/React.createElement("line", {
    id: "dda282fc-da1f-4a6c-8a76-02c44c517a3e",
    className: "cls-2",
    x1: 148,
    y1: 76.06,
    x2: 108,
    y2: 76.06
  }), /*#__PURE__*/React.createElement("line", {
    id: "be58f7bc-f76c-4f18-a0cf-1614bd7dae90",
    className: "cls-2",
    x1: 148,
    y1: 60.06,
    x2: 108,
    y2: 60.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 192,
    height: 192
  }));
}

var _default = ic_tv__epg__backwards;
exports.default = _default;